import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

class CopyButton extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isCopy: false,
      label: props.label || 'Copy',
      substitutionLabel: props.substitutionLabel || 'Copied',
      delay: props.delay || 1000
    };
    this.copy = this.copy.bind(this);
  }

  copy(e) {
    const { text } = this.props;
    const { label, substitutionLabel, delay } = this.state;
    navigator.clipboard.writeText(text);
    this.setState({ label: substitutionLabel });
    setTimeout(() => {
      this.setState({ label });
    }, delay);
  }

  getTarget = target => {
    this._target = target;
  };

  render() {
    const { label } = this.state;
    return (
      <Button color="primary" className="copy-button" onClick={this.copy}>
        {label}
      </Button>
    );
  }
}

CopyButton.propTypes = {
  text: PropTypes.string.isRequired,
  label: PropTypes.string,
  substitutionLabel: PropTypes.string
};

export default CopyButton;



// WEBPACK FOOTER //
// ./src/components/formFields/CopyButton.js